module.exports = __webpack_public_path__ + "img/1.2f0d4204.svg";